import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import { Text } from '@grandvisionhq/elements';

/**
 * This component is essentially the same as "elements/Text", but it
 * sets the margin to 0.Once we've gotten rid of all of the margins
 * on our components, this component will be obsolete.
 */ const CardText = (_param)=> {
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return React.createElement(Text, swcHelpers.extends({
        className: classnames('card-text', className)
    }, rest), children);
};
var CardText$1 = CardText;

export { CardText$1 as default };
//# sourceMappingURL=CardText.js.map
